import request from '@/utils/request'

//获取实验项目列表
export function getexperimentlist(params) {
    return request({
      url: '/portal/experiment/get-list',
      method: 'GET',
      params
    })
}